var _a;
import { createActions } from 'redux-actions';
export var getDevices = (_a = createActions('GET_DEVICES', 'GET_DEVICES_COMPLETE', 'GET_DEVICE_THEME'), _a.getDevices), getDevicesComplete = _a.getDevicesComplete, getDeviceTheme = _a.getDeviceTheme;
